module.exports = __webpack_public_path__ + "static/media/stream_woom_video_classes.b403487d.svg";